import { QueryBooleanSchema, SortModelSchema } from 'notable-common';
import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
export var FlowAgentState;
(function (FlowAgentState) {
    FlowAgentState["Active"] = "Active";
    FlowAgentState["SoftDeleted"] = "SoftDeleted";
})(FlowAgentState || (FlowAgentState = {}));
/**
 * Structural validation only. flow-api layers on a check that the name is free within the
 * organization, which needs the database and so cannot live here.
 */
export const FlowAgentCreateValuesSchema = z.object({
    name: z.string(),
    description: z.string().nullish(),
    category: z.string().optional().default('Placeholder'),
    organizationId: z.uuid(),
    state: z.enum(FlowAgentState).optional().default(FlowAgentState.Active),
    createdByUserId: z.uuid().optional(),
});
export const FlowAgentUpdateValuesSchema = z.object({
    name: z.string().optional(),
    description: z.string().nullish(),
    category: z.string().optional(),
    organizationId: z.uuid().optional(),
    state: z.enum(FlowAgentState).optional(),
});
/** Path parameters the endpoints addressing one agent accept. */
export const FlowAgentIdParamsSchema = z.object({
    id: z.uuid().describe('The agent.'),
});
export const FlowAgentFindAllOptionsSchema = z.object({
    q: z.string().optional(),
    organizationId: z.union([z.array(z.uuid()), z.uuid()]).optional(),
    state: z.enum(FlowAgentState).optional(),
    includeInactive: QueryBooleanSchema.optional().default(false),
    limit: FlowApiPageLimitSchema.describe('How many agents to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    /** @deprecated Legacy sort parameters; use `sortModel`. */
    orderBy: z.string().optional(),
    /** @deprecated Legacy sort parameters; use `sortModel`. */
    orderDirection: z.enum(['asc', 'desc']).optional(),
    sortModel: SortModelSchema.optional(),
});
//# sourceMappingURL=agent.js.map